isInTrial